<app-core-popup
  [dialogStyle]="{ width: '45rem' }"
  [header]="'İptal Et'"
  [saveText]="'common.save' | translate"
  (chooseOn)="save()"
  (closeOn)="onHide()"
  #corePopup
>
  <div *ngIf="showPopup">
    <div class="p-fluid">
      <!-- İptal Nedeni -->
      <div class="p-field">
        <label for="reason" class="required-star">İptal Nedeni</label>
        <p-dropdown
          id="reason"
          [options]="cancelReasons"
          [(ngModel)]="selectedReason"
          placeholder="Bir neden seçin"
          appendTo="body"
        ></p-dropdown>
      </div>

      <!-- Açıklama -->
      <div class="p-field mt-3">
        <label for="description">Açıklama</label>

        <textarea
          id="description"
          rows="4"
          [attr.maxlength]="255"
          class="form-control"
          [(ngModel)]="cancelDescription"
          placeholder="Ek açıklama girin..."
        ></textarea>
        <div class="text-end text-muted small">
          {{ currentLength }} / {{ 255 }}
        </div>
      </div>
    </div>
  </div>
</app-core-popup>
